module.exports = __webpack_public_path__ + "img/tarj2-2.f98e5a6c.png";